<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='14'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-row>
            <el-col :span="2" style="float: right;">
              <div style="padding-top:5px;padding-left:45px;" class="thisclose">
                <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
              </div>
            </el-col>
          </el-row>
          <div class="cght_subpagemaina">
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" style="width: 100%" v-loading="isLoading" border>
                  <el-table-column label="任务名称" align="center" width="300">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" placement="top">
                        <p>{{ scope.row.task_name }}</p>
                        <div slot="reference" class="name-wrapper">
                          <span>{{ scope.row.task_name }}</span>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="提出人" align="center" width="80">
                    <template slot-scope="scope">
                      <div slot="reference" class="name-wrapper">
                        <el-tag size="medium">{{ scope.row.name }}</el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="提交时间" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{ scope.row.subtime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="是否完成" width="110">
                    <template slot-scope="{row}">
                      <el-switch
                        style="display: block"
                        v-model="row.state"
                        active-value="2"
                        inactive-value="1"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="changeState(row)"
                        active-text="是"
                        inactive-text="否">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="跟进人" align="center" width="180">
                    <template slot-scope="scope">
                      <div slot="reference" class="name-wrapper">
                        <template v-for="(item,index) in scope.row.participant_list">
                          <span :key="index" size="medium" style="margin-left: 5px;margin-top: 5px;">{{ item.name }}</span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" width="300">
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{ scope.row.ramke }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="100">
                    <template slot-scope="scopes">
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <ul>
                          <li v-for="(item,index) in scopes.row.screenshot" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(item.response)">下载</el-button>
                            <!-- <span style="float: right;cursor: pointer;" @click="dowloadFile(item.response)">下载</span> -->
                          </li>
                        </ul>
                        <el-button v-if="scopes.row.screenshot.length > 0" slot="reference" size="mini" type="text">任务文件</el-button>
                      </el-popover>
                      <el-button slot="trigger" size="mini" type="text" @click="handleEdit(scopes.row)">文件上传</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="pctasklist" />
              </el-col>
            </el-row>
            <el-image
              style="width: 0px; height: 0px"
              :src="url"
              :lazy="true"
              ref="preview"
              :preview-src-list="srcList">
            </el-image>
            <el-image
              style="width: 0px; height: 0px"
              src="https://serv.nmzp.com/uploads/1/image/20240411/80a00fa3ad3f307570961bf8e65621e7.jpg"
              :lazy="true"
              ref="newpreview"
              :preview-src-list="newSrcList"
            >
            </el-image>
            <el-dialog
              title="文件上传"
              :visible.sync="dialogVisible"
              width="30%"
            >
              <el-upload
                ref="upload"
                class="upload-demo"
                list-type="text"
                :action="upload_url"
                :on-success="handlesuccess"
                :on-remove="removeUpload"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx,.docx,.doc,.jpg,.pdf,.zip,.rar"
                :file-list="myfileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="true"
              >
                <!-- <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" src="../../assets/images/scwj.jpg">
                  <span class="el-upload-list__item-actions">
                    <span  class="el-upload-list__item-delete" @click="removeUpload(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div> -->
                <el-button slot="trigger" size="mini" type="primary">上传文件</el-button>
              </el-upload>
              <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="subUploadFiel">确 定</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import apiConfig from '../../../config/api.config.js'
import api from '@/api/task'
import { getToken, getType } from '@/utils/auth'

export default {
  name: 'TaskAllocation',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      api,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'id',
        sort: 'DESC'
      },
      dialogVisible: false,
      form: {
        task_name: '',
        participant: '',
        sate: 0,
        task_id: '',
        screenshot: '',
        introducer: '',
        subtime: '',
        priority: '',
        ramke: ''
      },
      srcList: [],
      newSrcList: ['https://serv.nmzp.com/uploads/1/image/20240411/80a00fa3ad3f307570961bf8e65621e7.jpg'],
      url: '',
      isLoading: false,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      myfileList: [],
      rowID: ''
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    this.pctasklist()
  },
  methods: {
    handleEdit (row) {
      this.dialogVisible = true
      this.myfileList = row.task_file_list ? row.task_file_list : []
      this.rowID = row.id
    },
    pctasklist () {
      this.isLoading = true
      api.pctasklist(this.listQuery).then(response => {
        this.list = response.items
        this.total = response.total
        this.isLoading = false
      })
    },
    changeState (state) {
      api.changeState(state).then((response) => {
        this.$notify({ title: '成功', message: response.message, type: 'success', duration: 2000 })
      })
    },
    removeUpload (file, fileList) {
      this.myfileList = fileList
    },
    handlesuccess (response, file, fileList) {
      if (response.code === 20000) {
        this.myfileList = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const extension7 = testmsg === 'zip'
      const extension8 = testmsg === 'rar'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、pdf、zip、rar格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6 || extension7 || extension8) && isLt2M
    },
    handleClick (row) {
      const thisType = getType(row.screenshot)
      if (thisType === 'image') {
        this.srcList = [row.screenshot]
        this.url = row.screenshot
        this.$nextTick(() => {
          this.$refs.preview.clickHandler()
        })
      } else if (thisType === 'pdf') {
        window.open(row.screenshot, '_target')
      } else {
        const url = 'http://view.officeapps.live.com/op/view.aspx?src=' + row.screenshot
        window.open(url, '_target')
      }
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.newpreview.clickHandler()
      })
    },
    subUploadFiel () {
      api.subUploadFiel({task_file_list: this.myfileList, rowID: this.rowID}).then(res => {
        this.dialogVisible = false
        this.pctasklist()
      })
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 55px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/member/taskAllocation.vue